export default __webpack_public_path__ + "static/media/logo.aaeb0fa8.svg";